import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static outlets = ['v2--chart-component--chart-component']

  setChartType(e) {
    e.preventDefault()
    this.v2ChartComponentChartComponentOutlet.setChartTypeAndRebuildChart(e.params.chartType)
  }
}
